import { useV2RotateServiceAccountCredentialMutation } from "@generated";

interface RotateInput {
  userId: number;
  credentialId: number;
}

const useRotateClientCredential = () => {
  const [trigger, { isLoading }] =
    useV2RotateServiceAccountCredentialMutation();

  const rotateCredential = async (input: RotateInput): Promise<string> => {
    const result = await trigger({
      userId: input.userId,
      serviceAccountCredentialId: input.credentialId,
    }).unwrap();

    return result.data?.attributes["client-secret"] ?? "";
  };

  return { rotateCredential, isRotating: isLoading };
};

export default useRotateClientCredential;
